import "@mdi/font/css/materialdesignicons.css";

import "vuetify/styles";
import { VBtn, VContainer } from "vuetify/components";
import { createVuetify, type ThemeDefinition } from "vuetify";
import "~/assets/styles/main.css";
import "~/assets/styles/vuetify-variables.scss";
import colors from "vuetify/util/colors";
const customLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#2196f3",
    secondary: "#74E291",
    "secondary-background": "#e6fffe",
    "secondary-green-background": "#baffcd",
    "grey-background": "#202731",
    tertiary: colors.teal.lighten1,
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    "light-grey": colors.grey.lighten2,
    "dark-grey": colors.grey.darken1,
  },
};
export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    theme: {
      defaultTheme: "customLightTheme",
      themes: {
        customLightTheme,
      },
    },
    aliases: {
      VBtnAccent: VBtn,
      VBtnText: VBtn,
      VBtnBig: VBtn,
      VContainerRestricted: VContainer,
      VContainerRestrictedPt: VContainer,
      VContainerNp: VContainer,
    },
    defaults: {
      VTab: {
        class: ["rounded-0"],
        style: "border-radius: 0px !important",
      },
      VContainerRestricted: {
        style: "max-width: 1500px; padding: 0px var(--normal-page-padding)",
      },
      VContainerRestrictedPt: {
        style:
          "max-width: 1500px; padding: var(--normal-page-padding) var(--normal-page-padding) 0px var(--normal-page-padding)",
      },
      VContainer: {
        fluid: true,
      },
      VContainerNp: {
        fluid: true,
        class: ["pa-0"],
      },
      VBtn: {
        class: [, "rounded-xl"],
        color: "secondary",
        minHeight: "40px",
      },
      VBtnBig: {
        class: ["text-h6 px-8", "rounded-xl"],
        color: "secondary",
        minHeight: "55px",
      },
      VBtnAccent: {
        color: "surface",
        class: ["text-h6"],
        minHeight: "40px",
      },
      VStepperWindow: {
        class: ["ma-0"],
      },
      VStepperItem: {
        class: ["pa-2"],
      },
      VBtnText: {
        variant: "text",
        class: ["pa-1", "v-btn--text"],
        color: "primary",
        ripple: false,
      },
      VSelect: {
        variant: "outlined",
      },
      VTextField: {
        color: "primary",
        variant: "outlined",
        density: "comfortable",
      },
      VTextarea: {
        color: "primary",
        variant: "outlined",
        density: "comfortable",
      },
      VForm: {
        validateOn: "blur",
      },
      VDivider: {
        thickness: 1.5,
      },
    },
  });
  app.vueApp.use(vuetify);
});
